import React, { Component } from 'react';
import Field from 'redux-form/lib/Field';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Alert from 'react-bootstrap/lib/Alert';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FieldFormGroup from '../FieldFormGroup';
import styles from './styles.sass';

class RequestResetPassword extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleClickLogIn = this.handleClickLogIn.bind(this);
  }

  handleClickLogIn(evt) {
    const { clickLogIn } = this.props;
    evt.preventDefault();
    clickLogIn();
  }

  render() {
    const { error, handleSubmit, submitting } = this.props;
    return (
      <div>
        <p className="text-center">
          Type your email below, and we’ll email you a link to reset your
          password.
        </p>
        <form onSubmit={handleSubmit} id="form1">
          {error && <Alert bsStyle="danger">{error}</Alert>}
          <div>
            <Field
              name="email"
              placeholder="Email"
              component={FieldFormGroup}
              type="email"
            />
          </div>
          <FormGroup>
            <Button bsStyle="nav" block type="submit" disabled={submitting}>
              Reset Password
            </Button>
          </FormGroup>
        </form>
        <p className={`text-center ${styles.loginFooter}`}>
          <a onClick={this.handleClickLogIn}>Log in</a>
        </p>
      </div>
    );
  }
}

export default RequestResetPassword;
